import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { QueryClient, QueryClientProvider } from 'react-query';
import { SignedIn, SignedOut, UserButton } from '@clerk/clerk-react';
import LandingPage from './pages/LandingPage';
import UploadPage from './pages/UploadPage';
import LoadingPage from './pages/LoadingPage';
import LoadingProgressPage from './pages/LoadingProgressPage';
import SpendingPage from './pages/insights/SpendingPage';
import AnalysisPage from './pages/AnalysisPage';
import TopPurchasesPage from './pages/insights/TopPurchasesPage';
import MonthlySpendingPage from './pages/insights/MonthlySpendingPage';
import RideOrDiePage from './pages/insights/RideOrDiePage';
import FavoriteTimePage from './pages/insights/FavoriteTimePage';
import SpendingCategoriesPage from './pages/insights/SpendingCategoriesPage';
import ExpensiveDayPage from './pages/insights/ExpensiveDayPage';
import RealityCheckPage from './pages/insights/RealityCheckPage';
import TopStreaksPage from './pages/insights/TopStreaksPage';
import IncomeGapPage from './pages/insights/IncomeGapPage';
import MoneyWrappedPage from './pages/insights/MoneyWrappedPage';
import MoneyPersonalityPage from './pages/insights/MoneyPersonalityPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import SubscriptionCancelPage from './pages/SubscriptionCancelPage';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <>
          <header className="fixed top-0 right-0 p-2 z-50 flex items-center justify-end">
            <SignedIn>
              <UserButton 
                appearance={{
                  elements: {
                    userButtonAvatarBox: "w-8 h-8",
                    userButtonTrigger: "focus:shadow-none"
                  }
                }}
                afterSignOutUrl="/"
              />
            </SignedIn>
          </header>

          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              
              {/* Protected Routes */}
              <Route
                path="/upload"
                element={
                  <SignedIn>
                    <UploadPage />
                  </SignedIn>
                }
              />
              <Route
                path="/loading"
                element={
                  <SignedIn>
                    <LoadingPage />
                  </SignedIn>
                }
              />
              <Route
                path="/loading-progress"
                element={
                  <SignedIn>
                    <LoadingProgressPage />
                  </SignedIn>
                }
              />
              <Route
                path="/spending"
                element={
                  <SignedIn>
                    <SpendingPage />
                  </SignedIn>
                }
              />
              <Route
                path="/analysis"
                element={
                  <SignedIn>
                    <AnalysisPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/spending"
                element={
                  <SignedIn>
                    <SpendingPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/top-purchases"
                element={
                  <SignedIn>
                    <TopPurchasesPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/monthly-spending"
                element={
                  <SignedIn>
                    <MonthlySpendingPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/ride-or-die"
                element={
                  <SignedIn>
                    <RideOrDiePage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/favorite-time"
                element={
                  <SignedIn>
                    <FavoriteTimePage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/spending-categories"
                element={
                  <SignedIn>
                    <SpendingCategoriesPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/expensive-day"
                element={
                  <SignedIn>
                    <ExpensiveDayPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/reality-check"
                element={
                  <SignedIn>
                    <RealityCheckPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/top-streaks"
                element={
                  <SignedIn>
                    <TopStreaksPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/income-gap"
                element={
                  <SignedIn>
                    <IncomeGapPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/money-personality"
                element={
                  <SignedIn>
                    <MoneyPersonalityPage />
                  </SignedIn>
                }
              />
              <Route
                path="/insights/money-wrapped"
                element={
                  <SignedIn>
                    <MoneyWrappedPage />
                  </SignedIn>
                }
              />
              <Route path="/success" element={<SubscriptionSuccessPage />} />
              <Route path="/cancel" element={<SubscriptionCancelPage />} />
            </Routes>
          </Router>
        </>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;